var ref = require("prosemirror-model");
var DOMSerializer = ref.DOMSerializer;

var browser = require("./browser")
var ref$1 = require("./dompos");
var childContainer = ref$1.childContainer;

function getSerializer(view) {
  return view.someProp("domSerializer") || DOMSerializer.fromSchema(view.state.schema)
}

function draw(view, doc, decorations) {
  view.content.textContent = ""
  new Context(getSerializer(view), decorations).serializeContent(doc, view.content)
}
exports.draw = draw

function redraw(view, oldDoc, newDoc, oldDecorations, newDecorations) {
  var serializer = getSerializer(view)
  var onUnmountDOM = []
  view.someProp("onUnmountDOM", function (f) { onUnmountDOM.push(f) })

  function scan(dom, node, prev, oldDecorations, newDecorations) {
    var iPrev = 0, oPrev = 0, pChild = prev.firstChild
    var domPos = dom.firstChild
    while (domPos && (domPos.nodeType != 1 || domPos.hasAttribute("pm-ignore")))
      { domPos = movePast(domPos, view, onUnmountDOM) }

    var localDecorations = newDecorations.locals(node)
    var decoIndex = applyDecorations(localDecorations, 0, 0, 0, dom, domPos, false)

    function syncDOM() {
      while (domPos) {
        var curOff = domPos.nodeType == 1 && domPos.getAttribute("pm-offset")
        if (!curOff || +curOff < oPrev)
          { domPos = movePast(domPos, view, onUnmountDOM) }
        else
          { return +curOff == oPrev }
      }
      return false
    }
    var oldLocalDecorations, offset = 0, child
    function sameLocalDeco() {
      return compareDecorations(oldLocalDecorations || (oldLocalDecorations = oldDecorations.locals(prev)),
                                localDecorations, decoIndex,
                                oPrev, oPrev + pChild.nodeSize, offset, offset + child.nodeSize)
    }

    for (var iNode = 0; iNode < node.childCount; iNode++) {
      var matching = void 0, reuseDOM = void 0
      child = node.child(iNode)
      var found = pChild == child ? iPrev : findNodeIn(prev, iPrev + 1, child)
      if (found > -1) {
        matching = child
        while (iPrev != found) {
          oPrev += pChild.nodeSize
          pChild = prev.maybeChild(++iPrev)
        }
      }

      var childDeco = newDecorations.forChild(offset, child), prevChildDeco = void 0, matchedLocalDeco = void 0
      if (matching &&
          childDeco.sameOutput(prevChildDeco = oldDecorations.forChild(offset, child)) &&
          (matchedLocalDeco = sameLocalDeco()) != null &&
          syncDOM()) {
        reuseDOM = true
        decoIndex = matchedLocalDeco
      } else if (pChild && !child.isText && child.sameMarkup(pChild) &&
                 (matchedLocalDeco = sameLocalDeco()) != null && syncDOM()) {
        reuseDOM = true
        decoIndex = matchedLocalDeco
        if (!pChild.isLeaf)
          { scan(childContainer(domPos), child, pChild, prevChildDeco || oldDecorations.forChild(oPrev, pChild), childDeco) }
        domPos.setAttribute("pm-size", child.nodeSize)
      } else {
        var rendered = new Context(serializer, childDeco).serialize(child, offset)
        dom.insertBefore(rendered, domPos)
        reuseDOM = false
        decoIndex = applyDecorations(localDecorations, decoIndex, offset, offset + child.nodeSize, dom, rendered)
      }

      if (reuseDOM) {
        // Text nodes might be split into smaller segments
        if (child.isText) {
          for (var off = offset, end = off + child.nodeSize; off < end;) {
            if (offset != oPrev)
              { domPos.setAttribute("pm-offset", off) }
            off += +domPos.getAttribute("pm-size")
            domPos = domPos.nextSibling
          }
        } else {
          if (offset != oPrev)
            { domPos.setAttribute("pm-offset", offset) }
          domPos = domPos.nextSibling
        }
        oPrev += pChild.nodeSize
        pChild = prev.maybeChild(++iPrev)
        var end$1 = offset + child.nodeSize
        decoIndex = applyDecorations(localDecorations, decoIndex, end$1, end$1, dom, domPos)
      }
      offset += child.nodeSize
    }

    while (domPos) { domPos = movePast(domPos, view, onUnmountDOM) }

    if (node.isTextblock) { adjustTrailingHacks(serializer, dom, node) }

    if (browser.ios) { iosHacks(dom) }
  }
  scan(view.content, newDoc, oldDoc, oldDecorations, newDecorations)
}
exports.redraw = redraw

var Context = function Context(serializer, decorations) {
  this.serializer = serializer
  this.decorations = decorations
};

Context.prototype.onContent = function onContent (parent, target) {
  target.setAttribute("pm-container", true)
  this.serializeContent(parent, target, this.decorations)
};

Context.prototype.serialize = function serialize (node, offset) {
  var dom = this.serializer.serializeNodeAndMarks(node, this)
  if (dom.nodeType != 1 || dom.contentEditable == "false") {
    var wrap = document.createElement(node.isInline ? "span" : "div")
    wrap.appendChild(dom)
    dom = wrap
  }
  dom.setAttribute("pm-size", node.nodeSize)
  dom.setAttribute("pm-offset", offset)
  if (node.isTextblock) { adjustTrailingHacks(this.serializer, dom, node) }
  return dom
};

Context.prototype.serializeContent = function serializeContent (node, target) {
    var this$1 = this;

  var decorations = this.decorations
  var locals = decorations.locals(node)
  var i = applyDecorations(locals, 0, 0, 0, target, null, false)
  node.content.forEach(function (child, offset) {
    this$1.decorations = decorations.forChild(offset, child)
    var dom = target.appendChild(this$1.serialize(child, offset))
    i = applyDecorations(locals, i, offset, offset + child.nodeSize, target, dom)
  })
};

// : ([Decoration], number, number, number, dom.Node, ?dom.Node) → number
// Used to apply decorations, either at a given point in a node that's
// being updated, or those in and after a given child node. `i` is an
// index into the local set of (non-overlapping) decorations, which is
// used to avoid scanning through the array multiple times.
//
// When `from` == `to`, this should only draw inserted decorations at
// the given position. When `from` < `to`, this should also decorate a
// node. That node may be a text node, which may have different
// decorations at different points, in which case it has to be split.
//
// `domNode` should be _the node after `from`_. That means that it is
// the current node when `from` < `to`, and the node after the current
// position when they are equal. It may be null, when `from` == `to`
// and there are no nodes after the current point.
//
// Returns the updated index, which can be passed back to this
// function later.
function applyDecorations(locals, i, from, to, domParent, domNode) {
  var result = i
  for (; i < locals.length; i++) {
    var span = locals[i]
    if (span.from > to || (span.from == to && span.to > to)) { break }
    if (from < span.from) {
      domNode = span.from < to ? splitText(domNode, span.from - from) : domNode.nextSibling
      from = span.from
    }
    var curNode = domNode
    if (span.to < to && span.from < span.to) {
      domNode = splitText(domNode, span.to - from)
      from = span.to
    }

    for (;;) {
      curNode = span.type.apply(domParent, curNode)
      if (i < locals.length - 1 && locals[i + 1].to == span.to && locals[i + 1].from == span.from) { span = locals[++i] }
      else { break }
    }
    if (span.to <= to) { result = i + 1 }
  }
  return result
}

function compareDecorations(old, cur, i, oldFrom, oldTo, curFrom, curTo) {
  var j = 0, result = i
  while (j < old.length && old[j].to <= oldFrom) { j++ }
  for (;; i++, j++) {
    var oldEnd = j == old.length || old[j].from >= oldTo
    if (i == cur.length || cur[i].from >= curTo) { return oldEnd ? result : null }
    else if (oldEnd) { return null }
    var oldNext = old[j], curNext = cur[i]
    if (oldNext.type != curNext.type ||
        oldNext.from - oldFrom != curNext.from - curFrom ||
        oldNext.to - oldFrom != curNext.to - curFrom) { return null }
    if (curNext.to <= curTo) { result = i + 1 }
  }
}

function splitText(node, offset) {
  var inner = node
  while (inner.nodeType != 3) { inner = inner.firstChild }
  var newNode = document.createTextNode(inner.nodeValue.slice(offset))
  inner.nodeValue = inner.nodeValue.slice(0, offset)
  while (inner != node) {
    var parent = inner.parentNode, wrap = parent.cloneNode(false)
    wrap.appendChild(newNode)
    newNode = wrap
    inner = parent
  }
  node.parentNode.insertBefore(newNode, node.nextSibling)
  var size = +node.getAttribute("pm-size")
  newNode.setAttribute("pm-size", size - offset)
  node.setAttribute("pm-size", offset)
  newNode.setAttribute("pm-offset", +node.getAttribute("pm-offset") + offset)
  return newNode
}

function findNodeIn(parent, i, node) {
  for (; i < parent.childCount; i++) {
    var child = parent.child(i)
    if (child == node) { return i }
  }
  return -1
}

function movePast(dom, view, onUnmount) {
  var next = dom.nextSibling
  for (var i = 0; i < onUnmount.length; i++) { onUnmount[i](view, dom) }
  dom.parentNode.removeChild(dom)
  return next
}

function isBR(node, serializer) {
  if (!node.isLeaf || node.isText || !node.isInline) { return false }
  var ser = serializer.nodes[node.type.name](node)
  return Array.isArray(ser) ? ser[0] == "br" : ser && ser.nodeName == "BR"
}

function adjustTrailingHacks(serializer, dom, node) {
  var needs = node.content.size == 0 || isBR(node.lastChild, serializer) ||
      (node.type.spec.code && node.lastChild.isText && /\n$/.test(node.lastChild.text))
      ? "br" : !node.lastChild.isText && node.lastChild.isLeaf ? "text" : null
  var last = dom.lastChild
  var has = !last || last.nodeType != 1 || !last.hasAttribute("pm-ignore") ? null
      : last.nodeName == "BR" ? "br" : "text"
  if (needs != has) {
    if (has == "br") { dom.removeChild(last) }
    if (needs) {
      var add = document.createElement(needs == "br" ? "br" : "span")
      add.setAttribute("pm-ignore", needs == "br" ? "trailing-break" : "cursor-text")
      dom.appendChild(add)
    }
  }
}

function iosHacks(dom) {
  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
    var oldCSS = dom.style.cssText
    dom.style.cssText = oldCSS + "; list-style: square !important"
    window.getComputedStyle(dom).listStyle
    dom.style.cssText = oldCSS
  }
}



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-view/dist/draw.js
// module id = 851
// module chunks = 0